export const APP_ROUTES = {
    Register: "/register",
    Insights: "/insights",
    TrainingVideo: "/training-video",
    CheckinCheckout: "/checkin-checkout",
    Checkin: "/checkin",
    Checkout: "/checkout",
    DoctorImport: "/import/doctor",
    PharmacistImport: "/import/pharmacist",
    PatientImport: "/import/patient",
    ResponsibleLegalImport: "/import/responsible_legal",
    PatientResponsibleLegalImport: "/import/patient_responsible_legal",
    NurseImport: "/import/nurse",
    OrganizationImport: "/import/organization",
    OrganizationBranchImport: "/import/organization_branch",
    DoctorOrganizationBranchImport: "/import/doctor_organization_branch",
    DoctorPatientImport: "/import/doctor_patient",
    PharmacistOrganizationBranchImport: "/import/pharmacist_organization_branch",
    PeopleImport: "/import/people",
    InstitutionsImport: "/import/institutions",
    RelationshipImport: "/import/relationships",
    UserImport: "/import/user",
    PersonImport: "/import/person",
    AddressImport: "/import/address",
    TrainingGroup: "/training-group",
    Training: "/training",
    InstitutionalGroup: "/institutional-group",
    TrainingMaterial: "/training-material",
    TrainingCentral: "/training-central",
    MyTrainings: "/my-trainings",
    CompletedTrainings: "/training/completed",
    EmittedCertificates: "/certificates/emitted",
    ApiKeyManagement: "/system/api-keys",
    Institution: "/institution",
    InstitutionApproval: "/institution/approval",
    Return: "/return",
    Dispensing: "/dispensing",
    DispensingHistory: "/dispensing/history",
    DispensationCancellationRequests: "/dispensing/cancellation-requests",
    Patient: "/patient",
    Search: "/search",
    ForgotPassword: "/forgot-password",
    ResetPassword: "/reset-password",
    MFAVerification: "/login/mfa",
    SapConfiguration: "/system/sap-configuration",
    SsoSettings: "/system/sso-settings",
    SapCommunication: "/system/sap-communication",
    SapHomologatedInstitutions: "/sap-institutions",
    LogsReport: "/logs/report",
    SsoLogin: "/sso-login",
    SsoCallback: "/auth/sso/callback",
    MyPatients: "/my-patients",
    MyPrescriptionDispensation: "/my-prescription-dispensation",
    About: "/about",
    CreateAccount: "/create_account",
    PrescriptionHistory: "/prescription-history",
    ProfileSettings: "/profile-settings",
    HelpCenterManualUpload: "/admin/help-center-manual-upload",
    TrainingVideoDetail: "/training-video/:pk",
    InstitutionSetup: "/institution_setup",
    InstitutionCentral: "/institution/central",
    InstitutionStock: "/institution/stock",
    StockReconciliation: "/institution/stock/reconciliation",
    StockManagement: "/admin/stock-management",
    UserManagement: "/admin/user-management",
    PendingAccountApprovals: "/admin/pending-account-approvals",
    TraceabilitySap: "/admin/traceability",
    DataManagement: "/admin/data-management",
    AdvancedAudit: "/advanced-audit",
    DirectorGroups: "/admin/director-groups",
    InstitutionPartnerGroups: "/admin/institution-partner-groups",
    InstitutionManagement: "/admin/institution-management",
    ReturnQuality: "/quality/returns",
    ReturnManagement: "/return-management",
    PrescriptorSettings: "/system/prescriptor-settings",
    ContentSettings: "/system/content",
    Analytics: "/analytics",
    AnalyticsSales: "/analytics/sales",
    AnalyticsTraceability: "/analytics/traceability",
    AnalyticsProduction: "/analytics/production",
    ReportsPrescriptionDispensation: "/reports/prescription-dispensation",
    ReportsPrescriptions: "/reports/prescriptions",
    ReportsDispensations: "/reports/dispensations",
    ReportsPatients: "/reports/patients",
    ReportsInstitutions: "/reports/institutions",
    ReportsDoctors: "/reports/doctors",
    ReportsPharmacists: "/reports/pharmacists",
    ReportsPrescriptionsDispensations: "/reports/prescriptions-dispensations",
    ReportsDirectChannelClients: "/reports/direct-channel-clients",
    ReportsDistributorClients: "/institution/partners-by-distributor",
    ReportsDistributorClientsDetail: "/institution/partners-by-distributor/:distributorPk",
    Partner: "/partner",
    PartnerBranch: "/partner-branch",
    PartnerBranchDetail: "/partner-branch/:matrizPk",
    SystemNotice: "/system/notices",
    SystemNoticeDetail: "/system/notices/:noticePk",
    MyDownloads: "/my-downloads",
};
